// src/ErrorLogModal.tsx
import React from "react";
import "./ErrorLogModal.css";

export interface IError {
  type: "error" | "success";
  message: string;
  title: string;
  time: string;
}

export interface ErrorLogModalProps {
  logs: IError[];
  onClose: () => void;
  onClear?: () => void;
}

const ErrorLogModal: React.FC<ErrorLogModalProps> = ({
  logs,
  onClose,
  onClear,
}) => {
  return (
    <div className="error-modal-overlay">
      <div className="error-modal-container">
        <h2 className="error-modal-title">Progress Logs</h2>

        {logs.length === 0 ? (
          <div className="error-log-entry">No logs available.</div>
        ) : (
          logs.map((log, index) => (
            <div key={index} className={`error-log-entry error-${log.type}`}>
              <strong>{log.title}</strong> [{log.type}] - {log.message}{" "}
              <em>{log.time}</em>
            </div>
          ))
        )}
        <div style={{display: "flex", flexDirection: "row", justifyContent: "space-between", padding: "5px", alignItems: "center"}}>
          <button className="error-close-button" onClick={onClose}>
            Close
          </button>
          <button className="error-close-button" onClick={onClear}>
            Clear
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorLogModal;
